import * as hooks from './hooks';

export const useLottoIntegration = () => {
    hooks.useLottoRootURL();
    hooks.useLottoDestroyOnLangChange();
    hooks.useLottoFetch();
    hooks.useLottoInit();
    hooks.useLottoCookie();
    hooks.useLottoListeners();
    hooks.useLottoSyncSession();
};
